import * as types from '../../lib/constants';
import ConfigManager from '../../lib/common/configManager/configManager';

const initialState = {
  dictionary: ConfigManager.getLanguageDictionary(),
};

export default function dictionaryReducer(state = initialState, action) {
  switch (action.type) {
    case types.INIT_DICTIONARY:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/demo/reducers/dictionary.js